import { CSVColumnKey } from './types';
import { ColumnValidation, ValidationRule } from '../google-sheets/googleSheets';

export type GSValidation = {
  condition: {
    type: string;
    values: {
      userEnteredValue: string;
    }[];
  };
  strict: boolean;
  showCustomUi: boolean;
};

const yesOrNoValidation: ValidationRule = {
  condition: {
    type: 'ONE_OF_LIST',
    values: [{ userEnteredValue: 'YES' }, { userEnteredValue: 'NO' }],
  },
  strict: true,
  showCustomUi: true,
};

// const yesOrNoValidationString = JSON.stringify(yesOrNoValidation);

const booleanFields: Partial<Record<CSVColumnKey, ValidationRule>> = {
  enabled: yesOrNoValidation,
  is_over_the_counter: yesOrNoValidation,
  use_limited_quantity: yesOrNoValidation,
  use_inventory_management: yesOrNoValidation,
  is_age_restricted_item: yesOrNoValidation,
  delivery_handshake: yesOrNoValidation,
};

export const getValidations = (selectedColumns: Partial<CSVColumnKey>[]) => {
  return selectedColumns.reduce<ColumnValidation[]>((acc, key, idx) => {
    if (key) {
      const validation = booleanFields[key];
      if (validation) {
        acc.push({ columnIndex: idx, rule: validation });
      }
    }
    return acc;
  }, []);
};
